import { useState, useEffect } from "react";
import { ProductCard } from "../Components/ProductCard";
import Breadcrumb from "../Components/Breadcrumb";
import { ProductType } from "../Components/Products";
import { LoadingSpinner } from "../Components/LoadingSpinner";
import axios from "axios";
import {debounce} from 'lodash';
import { SearchBar } from "../Components/SearchBar";
import { Helmet } from "react-helmet-async";

export const ProductList =  () => {
  const [products, setProducts] = useState<ProductType[]>();


  const fetchProducts =async (queryString: string = '')=>{
    const response = await axios.get(`/api/product?category=1&page=1&limit=100&search=${queryString}`);

    if (response != null) {
      setProducts(response.data.products);
    }
  }

  const handleSearchChange = debounce(async (search:string)=>{
    fetchProducts(search);
  }, 500)

  useEffect(() => {
    fetchProducts()
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    return ()=>{
      handleSearchChange.cancel();
    }
  },[handleSearchChange])
    return (
      <>
      <Helmet>
        <title>Best Peptide Synthesizer for R & D and subsequent scale up process.</title>
        <meta name='description' content='Explore high-performance peptide synthesizers ideal for research to pilot-scale production. Discover how our technology helps to generate high yield, low waste, and cost-effective peptide synthesis solutions.' />
      </Helmet>
      <div className="xl:px-32 lg:px-20 md:px-10 px-5 mb-5">
      <div className="flex sm:justify-between sm:items-center mb-5 sm:mb-0 sm:flex-row flex-col">

        <div className='md:my-5 my-3'>
            <h1 className='font-bold text-xl md:text-2xl'>Peptide Synthesizers</h1>  
            <Breadcrumb />
        </div>
        <SearchBar onChange={handleSearchChange} />
      </div>
        {products?.length === 0 && <div className='text-2xl font-bold flex justify-center items-center h-[63vh]'>
                <p className='-mt-32'>
                    No products found
                </p>
            </div>}
        {products ? <div className="grid sm:grid-cols-2   md:grid-cols-3 gap-5">
          {products &&
            products.map((product, index) => {
              return <ProductCard key={index} {...product} />;
            })}
        </div> :  <LoadingSpinner />}
      </div>
      </>
    );
  
};
